import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAlertCheckCircle, LazyAlertTriangle, LazyBuilding, LazyCheck, LazyChevronDown, LazyChevronLeft, LazyDownload, LazyEdit, LazyExternalLink, LazyEye, LazyEyeOff, LazyFacebook, LazyFolder, LazyInfo, LazyInstagram, LazyLink2, LazyLinkedin, LazyLogOut, LazyLogoClub, LazyMail, LazyMapPin, LazyMenu, LazyNoImage, LazyPaperClip, LazySearch, LazySettings, LazyTrash, LazyUploadPicture, LazyUser, LazyUserCheck, LazyX, LazyXCircle, LazyYoutube, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["AlertCheckCircle", LazyAlertCheckCircle],
["AlertTriangle", LazyAlertTriangle],
["Building", LazyBuilding],
["Check", LazyCheck],
["ChevronDown", LazyChevronDown],
["ChevronLeft", LazyChevronLeft],
["Download", LazyDownload],
["Edit", LazyEdit],
["ExternalLink", LazyExternalLink],
["Eye", LazyEye],
["EyeOff", LazyEyeOff],
["Facebook", LazyFacebook],
["Folder", LazyFolder],
["Info", LazyInfo],
["Instagram", LazyInstagram],
["Link2", LazyLink2],
["Linkedin", LazyLinkedin],
["LogOut", LazyLogOut],
["LogoClub", LazyLogoClub],
["Mail", LazyMail],
["MapPin", LazyMapPin],
["Menu", LazyMenu],
["NoImage", LazyNoImage],
["PaperClip", LazyPaperClip],
["Search", LazySearch],
["Settings", LazySettings],
["Trash", LazyTrash],
["UploadPicture", LazyUploadPicture],
["User", LazyUser],
["UserCheck", LazyUserCheck],
["X", LazyX],
["XCircle", LazyXCircle],
["Youtube", LazyYoutube],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
